export const MODERATOR_PROFILE = 'moderator-profile';
export const PARTNER_PROFILES = 'partner-profiles';
export const KVIZOVI = 'kvizovi';
